/** User-facing copy for the support page. */

import { ROUTES } from "../../constants/routes";

export const CONTACT_EYEBROW = "Support";

export const CONTACT_TITLE = "Talk to a human.";

export const CONTACT_SUBTITLE =
  "Bugs, billing, or something just won't work — write to us and a person reads it. No ticket numbers, no bot.";

export const CONTACT_CTA = "Email support";

export const CONTACT_RESPONSE_NOTE =
  "We usually reply within a day. If you're stuck mid-project, say so and we'll jump you up the queue.";

export const CONTACT_INCLUDE_HEADING = "What gets you a faster answer";

export const CONTACT_INCLUDE_INTRO =
  "None of this is required — but each one saves us a round trip.";

export const CONTACT_INCLUDE_ITEMS = [
  "The email address on your CherryClipz account",
  "A screenshot of what you're looking at",
  "Whether it happened on the website or in the Premiere panel",
  "What you were doing right before it went wrong",
];

export const CONTACT_SELF_SERVE_HEADING = "Faster than emailing us";

export const CONTACT_SELF_SERVE = [
  {
    label: "Change your card or cancel",
    note: "Both are self-serve on your subscription page.",
    route: ROUTES.SUBSCRIPTION_MANAGE,
  },
  {
    label: "Install the Premiere panel",
    note: "Download plus the two-minute setup steps.",
    route: ROUTES.PLUGIN_DOWNLOAD,
  },
];
